import React from "react";

const InformerWidget = ({
  up,
  down,
  negative,
  positive,
  arrowDown,
  arrowUp,
  primary,
  warning,
  info,
  success,
  danger,
  text,
  description
}) => {
  let _icon = "";
  let _sign = null;
  let _separator = ["dev-informer"];

  if (down) {
    _icon = <i className="fa fa-caret-down text-danger" />;
  }
  if (up) {
    _icon = <i className="fa fa-caret-up text-success" />;
  }
  if (positive) {
    _sign = <span className="text-success">+ </span>;
  }
  if (negative) {
    _sign = <span className="text-danger">- </span>;
  }
  if (arrowDown) {
    _icon = <i className="fa fa-long-arrow-down text-danger" />;
  }
  if (arrowUp) {
    _icon = <i className="fa fa-long-arrow-up text-success" />;
  }
  if (primary) {
    _separator.push("dev-informer-primary");
  }
  if (info) {
    _separator.push("dev-informer-info");
  }
  if (warning) {
    _separator.push("dev-informer-warning");
  }
  if (success) {
    _separator.push("dev-informer-success");
  }
  if (danger) {
    _separator.push("dev-informer-danger");
  }
  return (
    <div className={_separator.join(" ")}>
      <div class="dev-informer-value">
        {_sign}
        {text} {_icon}
      </div>
      <div class="dev-informer-description">{description}</div>
    </div>
  );
};

export default InformerWidget;



// WEBPACK FOOTER //
// ./src/_components/UI/InformerWidget/index.js